import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const TrackAddDialog = ({open, handleClose, handleAddTrackFile, trackType}) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby='addTrack-dialog-title'
            aria-describedby='addTrack-dialog-description'
        >
            <DialogTitle id='addTrack-dialog-title'>{'Загрузка трека'}</DialogTitle>
            <DialogContent>
                <DialogContentText id='addTrack-dialog-description'>
                    {'Нажмите продолжить, чтобы выбрать трек для загрузки'}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClose}
                    color='primary'
                >
                    Отмена
                </Button>
                <input
                    accept='.mp3'
                    id='text-button-dialogAddFile'
                    multiple
                    type='file'
                    style={{display: 'none'}}
                    onChange={async (event) => {
                        handleClose();
                        await handleAddTrackFile(event, trackType);
                    }}
                />
                <label htmlFor='text-button-dialogAddFile'>
                    <Button
                        component={'span'}
                        color={'secondary'}
                    >
                        Продолжить
                    </Button>
                </label>
            </DialogActions>
        </Dialog>
    );
}

export default TrackAddDialog;

TrackAddDialog.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    handleAddTrackFile: PropTypes.func,
    trackType: PropTypes.string
};
